export default __webpack_public_path__ + "static/media/flag-guernsey.3a0bb3aa.svg";